import { useQuery } from '@tanstack/react-query'
import { useCallback } from 'react'
import { useAccessToken } from '../../useAccessToken'
import useProjectId from '../../../customHooks/useProjectId'
import { AggTranslations } from '../../../../../interfaces/grids/performance/AggTranslation'
import { useProjektprognosInteractionContext } from '../../../context/ProjektprognosInteractionContext'
import { apiRequestParams } from '../../fetchOptions'
import { makeResultFetch } from '../../genericFetch'
import { useHandleRetry } from '../../useHandleRetry'

export const useProjektprognosPerformanceTotals = (options?: {
  enabled?: boolean
}) => {
  const getAccessToken = useAccessToken()
  const projectId = useProjectId()
  const { loadProjektprognos } = useProjektprognosInteractionContext()
  const handleRetry = useHandleRetry()

  const queryFunction = useCallback(async () => {
    return getAccessToken().then((accessToken) => {
      if (!accessToken) throw new Error('Access token is undefined')

      const fetchedData = makeResultFetch<AggTranslations>(
        `/Sheet/${projectId}/Performance/Totals`,
        apiRequestParams(accessToken, 'GET')
      ).then((response) => {
        const { data, message, success } = response

        if (!success) throw Error(message)

        return data
      })

      return fetchedData
    })
  }, [getAccessToken, projectId])

  const query = useQuery({
    queryKey: [projectId, 'performanceTotals'],
    queryFn: queryFunction,
    enabled: !!projectId && !!queryFunction && (options?.enabled ?? true),
    retry: handleRetry,
  })

  return {
    ...query,
    isLoading: query.isLoading || loadProjektprognos,
  }
}
